import Axios, { AxiosResponse } from 'axios'
import { EnvironmentSecrets } from '@/models/environment/environment-secrets'
import storeMutations from '@/storeMutations'
import { getBaseUrl } from './CallCentreApiAxiosPlugin'
import { log } from '@/lib/logging'

export default class EnvironmentController {
  public static async RetrieveEnvironmentSecrets(accessToken: string) {
    try {
      const url = `${getBaseUrl()}Environment/RetrieveEnvironmentSecrets`

      const result: AxiosResponse<EnvironmentSecrets> = await Axios.get(url, {
        validateStatus: (s) => true,
        headers: {
          'Cache-Control': 'no-cache, no-store',
          Authorization: `bearer ${accessToken}`,
        },
      })

      if (result.status === 200) {
        storeMutations.setEnvironmentSecrets(result.data)
      } else {
        log('Error loading environment secrets', { level: 'error', context: { result } }).notifyUser(
          'Error loading environment secrets, please contact support'
        )
      }
    } catch (error) {
      log('Error loading environment secrets', { level: 'error', error }).notifyUser(
        'Error loading environment secrets, please contact support'
      )
    }
  }
}
